import { t } from '@/utility/localization';

export const MAGIC_REACH_TAB_SENT_ID = 'sent';
export const MAGIC_REACH_TAB_DRAFTS_ID = 'drafts';
export const MAGIC_REACH_TAB_AUTOMATED_EMAILS = 'automatedEmails';
export const MAGIC_REACH_MESSAGE_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  PROCESSING: 'processing',
  PROCESSING_FAILED: 'processing_failed',
  REVIEWING: 'reviewing',
  BLOCKED: 'blocked',
  SCHEDULED: 'scheduled'
};

export const ANALYTICS_TYPES = {
  ANNOUNCEMENT: {
    TOTAL_IMPRESSIONS: 'TOTAL_IMPRESSIONS'
  },
  WHATSAPP: {
    FIRST_MESSAGE_SENT: 'FIRST_MESSAGE_SENT',
    FIRST_MESSAGE_READ: 'FIRST_MESSAGE_READ',
    FULL_MESSAGE_SENT: 'FULL_MESSAGE_SENT',
    FULL_MESSAGE_READ: 'FULL_MESSAGE_READ',
    EARNINGS: 'EARNINGS'
  },
  EMAIL: {
    TOTAL_SENT: 'TOTAL_SENT',
    SENT: 'SENT',
    OPEN_RATE: 'OPEN_RATE',
    CLICK_RATE: 'CLICK_RATE',
    BOUNCE_RATE: 'BOUNCE_RATE',
    EARNINGS: 'EARNINGS'
  }
};

export const WHATSAPP_MESSAGE_TYPES = {
  INITIATE_MESSAGE: 'initiateMessage',
  LAST_REPLY_MESSAGE: 'lastReplyMessage'
};

export const MESSAGE_RECIPIENT_PAGE_SIZE = 20;
export const SKELETON_ITEM_NUMBER = 5;

export const MAGIC_REACH_POLLING_INTERVAL_MS = 10000;

export const NON_ANALYTICS_PLATFORMS = ['Announcement'];

export const MESSAGE_PLATFORMS = {
  EMAIL: 'Email',
  ANNOUNCEMENT: 'AnnouncementV2',
  DISCORD: 'DiscordV2',
  WHATSAPP: 'Whatsapp'
};

export const getMagicReachTabs = () => [
  { id: MAGIC_REACH_TAB_SENT_ID, label: t('messages') },
  { id: MAGIC_REACH_TAB_AUTOMATED_EMAILS, label: t('automated-emails') }
];

export const PLATFORM_ORDER = [
  MESSAGE_PLATFORMS.EMAIL,
  MESSAGE_PLATFORMS.ANNOUNCEMENT,
  MESSAGE_PLATFORMS.WHATSAPP,
  MESSAGE_PLATFORMS.DISCORD
];
